// extracted by mini-css-extract-plugin
export var productImage = "_ox-0";